<template>
  <v-container>
    <v-card>

      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold"> Firmantes Para Sentencia</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/escritos/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <!-- <v-btn color="#0A4A79" dark to="/escritos/show" small class="ml-3">
          <v-icon small class="mr-5">mdi-file</v-icon>
          Ir al Escrito
        </v-btn> -->
      </v-card-title>
      <!-- <v-divider inset></v-divider> -->
      <!-- <v-divider inset></v-divider> -->
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <!-- <v-col cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Seleccione los Magistrados por firmar</h3>
            </v-col> -->
            <!-- <v-col v-if="currentOrden.tipo == 2" cols="12" md="4" align="right">
              <v-btn v-if="currentOrden.previo_contestacion" small color="blue darken-3" dark @click="getFile()">
                <v-icon small left>mdi-file-document</v-icon>
                ver Acuerdo</v-btn>
            </v-col> -->
          </v-row>
          <br>

          <!-- Multifirma -->

          <v-card>
            <v-list
              shaped
            >
            <v-subheader>
              <!-- <h2 v-if="currentOrden.proceso_multifirma == 0" style="color: #B08836" class="font-weight-bold">Registrar</h2> -->
              <h2 style="color: #B08836" class="font-weight-bold">{{formTitle}}</h2>
              <v-spacer></v-spacer>
              <!-- <v-btn small dark color="blue darken-3" @click="getFile()">
                <v-icon small left>mdi-file-document</v-icon>
                ver Sentencia
              </v-btn> -->
              <!-- <v-toolbar-title v-if="currentOrden.proceso_multifirma == 0">Registrar</v-toolbar-title>
              <v-toolbar-title v-else>Editar</v-toolbar-title> -->
            </v-subheader>
            <!-- <h3 color="blue" v-if="currentOrden.proceso_multifirma == 0">Registrar</h3>
            <h3 color="blue" v-else>Editar</h3> -->

          </v-list>
          <v-card-text>
          <v-row>
            <v-col cols="12" md="">
              <v-autocomplete
                v-if="roleUser == 'superadmin'"
                v-model="salaSelected"
                :items="salasList"
                dense
                item-text="nombre"
                item-value="id"
                return-object
                label="Selecciona Área"
                prepend-icon="mdi-gavel"
                outlined
                persistent-hint
                no-data-text="No se Encontraron Áreas"
                required
                :rules="[v => !!v|| 'Seleccione el Área']"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-n7">
            <v-col cols="12" sm="5">
              <v-text-field
              outlined
              dense
              v-model="toca"
              label="Número de Toca"
              prepend-icon="mdi-folder"
              min='1'
              placeholder="1234/2021"
              :rules="tocaRules"
              >
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="4">
              <v-select
              outlined
              v-model="tipo"
              :items="tipoDocumento"
              dense
              item-text="nombre"
              item-value="id"
              label="Tipo de documento"
              prepend-icon="mdi-folder"
              :rules="[v => !!v|| 'Seleccione el Tipo de documento']"
              >
              </v-select>
            </v-col> -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="dialogFecInicio"
                v-model="dialogFecInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_sentencia"
                    label="Fecha Sentencia"
                    prepend-inner-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    dense
                    clearable
                    outlined
                    :rules="[v => !!v|| 'Seleccione la Fecha']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_sentencia"
                  @input="dialogFecInicio = false"
                  locale="es-mx"
                  min="2010-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
            <!-- <v-row v-if="!currentOrden.previo_contestacion" class="mt-n1 ml-6"> -->
             <v-row class="mt-n7">
              <v-col cols="12" md="12" align="center">
                <v-file-input
                  v-model="file"
                  label="Seleccione el Documento"
                  dense
                  outlined
                  show-size
                  accept="application/pdf"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="fileSelected()"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row class="mt-n7">
              <v-col cols="12" md="12">
                <v-autocomplete
                  v-model="magistrado"
                  :items="listMagistrados"
                  dense
                  outlined
                  @change="addMagistrado()"
                  item-text="nombre"
                  item-value="id"
                  return-object
                  label="Seleccione al Magistrado"
                  prepend-icon="mdi-account"
                  persistent-hint
                  no-data-text="No se Encontraron Magistrados"
                  required
                >
                <template slot="selection" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                <template slot="item" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="2">
              <v-btn small color="blue darken-3" dark @click="addMagistrado()">
                <v-icon small left>mdi-plus</v-icon>
                Agregar
              </v-btn>
              </v-col> -->
            </v-row>
          </v-card-text>

            <v-container v-if="magistrados.length > 0">
            <v-card class="mt-n7">
              <v-card-title style="color: #B08836"  class="font-weight-bold">
                <h3 class="heading font-weight-bold"> Firmantes del Documento</h3>
              </v-card-title>
              <v-row class="mt-n1">
                <v-col cols="12" md="10">
                  <ul>
                    <li
                      v-for="(magistrado,index) in magistrados"

                      v-on:remove="magistrados.splice(index, 1)"
                    >
                <h3 v-if="magistrado.segundo_apellido">
                  {{magistrado.nombre+' '+magistrado.primer_apellido+' '+magistrado.segundo_apellido}}
                  <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                </h3>
                <h3 v-else>
                  {{magistrado.nombre+' '+magistrado.primer_apellido}}
                  <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                </h3>
                <b v-if="magistrado.firmado == 1" style="color: green">Ya ha Firmado</b>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-container><br>

          </v-card><br>

          <v-row>
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Registrar
              </v-btn>
              <!-- <v-btn
                v-if="currentOrden.status == 2 && currentOrden.proceso_multifirma == 1"
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="editar()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Actualizar Firmantes
              </v-btn> -->
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        salasList: [],
        loading: false,
        progress: false,
        valid: true,
        dialogFecInicio: false,
        fecha_sentencia: '',
        currentOrden:'',
        files:[],
        file:[],
        url_firmas:'',
        salaSelected:'',
        toca:'',
        tipo: 1,
        // nombre_contestacion:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        tipoDocumento: [
          { id: 1, nombre: 'Sentencias'},
          { id: 2, nombre: 'Amparos' }
        ],
        // sign:true,
        tocaRules: [
          v => !!v.trim().length || 'Ingrese el Número de Toca',
          v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
        ],
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB',
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      formTitle () {
        // if (this.currentOrden.proceso_multifirma === 1) {
        //   return 'Editar'
        // }
        return 'Registrar'
      },
      ...mapGetters(["currentUser", "roleUser", "listMagistrados", "firmasList"]),
    },
    mounted() {
      this.getMagistrados()
      this.getSalas()
      // this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
      // this.listParafirma()
    },
    methods:{
      // listParafirma(){
      //   if (this.currentOrden.proceso_multifirma == 1) {
      //     this.getFirmas()
      //   }
      // },

      // getFirmas() {
      //   this.$store.dispatch("GET_FIRMAS",  { url: "/multifirma/"+ this.currentOrden.id +"/firmas" })
      //     .then(response => {
      //       // console.log(response.data);
      //       let firmas = response.data.data.firmas
      //         firmas.forEach(firma => {
      //           // this.magistrados.firmado = firma.firmado
      //           // console.log(firma.firmado);
      //           firma.magistrado.firmado = firma.firmado
      //           this.magistrados.push(firma.magistrado)
      //           this.magistrados_ids.push(firma.magistrado_id)
      //       });
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      // },

      getMagistrados(){
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" })
          .then(response => {
            // console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSalas() {
        this.salaSelected = ''
        this.$store.dispatch("GET_SALAS",  { url: "/salas",
        }).then(response => {
          // console.log(response.data);
          this.salasList = response.data.data.salas
        })
        .catch(err => {
          console.log(err);
        });
      },

      validate() {
        // console.log(this.file);
        if (this.$refs.form.validate()) {
          if (this.file == "" || this.file == null) {
            Swal.fire({
              icon: 'warning',
              title: 'Selecciona un Acuerdo',
              confirmButtonText: "Aceptar",
            })
            this.loading = false
          }
          else if(this.magistrados_ids.length == 0){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Magistrados',
              confirmButtonText: "Aceptar",
            })
          } else
          {
            if (this.tipo == 1) {
              this.url_firmas = "/sentencia"
            }
            // if (this.tipo == 2) {
            //   this.url_firmas = "/amparo"
            // }
            this.loading = true
            // this.url_firmas = "/sentencia"
            this.saveMultifirma()
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },

      // editar() {
      //     if(this.magistrados_ids.length == 0){
      //       Swal.fire({
      //         icon: 'warning',
      //         title: 'Favor de Agregar Magistrados',
      //         confirmButtonText: "Aceptar",
      //       })
      //     } else
      //     {
      //       this.loading = true
      //       this.url_firmas = "/promocion/"+ this.currentOrden.id +"/multifirma"
      //       this.editMultifirma()
      //     }
      // },

      saveMultifirma() {
        this.FilesToUpload()
        var toca = this.toca
        var sala_id = this.currentUser.sala_id;
          toca = toca.split("/",3)
          this.numero = toca[0];
          this.periodo = toca[1];
          this.derivado = toca[2];
          if (this.roleUser != "secacuerdos") {
            sala_id = this.salaSelected.id
          }

        const data = {
          sala_id: sala_id,
          // tipo: this.tipo,
          fecha_sentencia: this.fecha_sentencia,
          numero: this.numero,
          periodo: this.periodo,
          derivado: this.derivado,
          secretario_id: this.currentUser.id,
          magistrados: this.magistrados_ids,
          file: this.archivo
          // nombre: this.nombre_contestacion
        }
        this.$store.dispatch("CREATE_SENTENCIA",  { url: this.url_firmas, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Sentencia y Firmantes Registrados con Éxito',
            timer: 1500,
          })
          this.loading = false
          // this.showPromocion()
          // this.close();
          this.$router.push('/escritos/panel')
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      // showPromocion(){
      //   this.$store.dispatch("SHOW_PROMOCION", {
      //     url:"/promocion/"+ this.currentOrden.id,
      //   } )
      //   .then((response) => {
      //   this.$router.push('/escritos/show' )
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
      // editMultifirma() {
      //   const data = {
      //     magistrados: this.magistrados_ids
      //   }
      //   this.$store.dispatch("EDIT_MULTIFIRMA",  { url: this.url_firmas, data: data })
      //   .then(response => {
      //     Swal.fire({
      //       icon: 'success',
      //       title: 'Firmantes Actualizados con Éxito',
      //       timer: 1500,
      //     })
      //     this.loading = false
      //     // this.close();
      //     this.$router.push('/escritos/show')
      //   })
      //     .catch(error => {
      //       this.loading = false
      //       console.log(error);
      //       Swal.fire({
      //         icon: 'error',
      //         title: 'Error',
      //         text: error.response.data.message,
      //         confirmButtonText: "Aceptar"
      //       });
      //       // this.close();
      //     });
      // },
      fileSelected(){
        var file = this.file;
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['file_name'] = this.file.name.split(".pdf")[0];
            // console.log(this.archivo.file_name);
          });
        }
      },

      addMagistrado() {
        if (this.magistrado=="") {
          Swal.fire({
            icon: 'warning',
            title: 'No se ha seleccionado Magistrado',
            showConfirmButton: false,
            timer: 1500
          })
        } else if (this.magistrados_ids.includes(this.magistrado.id)) {
          Swal.fire({
            icon: 'warning',
            title: this.magistrado.nombre + ' ya ha sido agregado',
            showConfirmButton: false,
            timer: 1500
          })
          this.magistrado = ''
          // this.$refs.form.reset()
        } else {
          this.magistrados.push(this.magistrado)
          this.magistrados_ids.push(this.magistrado.id)
          this.magistrado = ''
          // this.$refs.form.reset()
        }
      },
      // getFile(){
      //   this.progress = true
      //   this.$store.dispatch("GET_FILE", { url: "/promocion/"+ this.currentOrden.id +"/previo-multifirma" }).then((response) => {
      //       const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      //       const link = document.createElement('a');
      //       link.href = url;
      //       link.setAttribute('target' ,'_blank');
      //       document.body.appendChild(link);
      //       link.click();
      //       this.progress = false
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.progress = false
      //     });
      // },

      removeMagistrado(index) {
        this.magistrados.splice(index, 1)
        this.magistrados_ids.splice(index, 1)
      },

      close () {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        this.files = []
        this.file = []
      },

    }
  }
</script>
